/*
 * @Author: Gaho
 * @Date: 2024-03-06 13:17:12
 * @LastEditors: Gaho
 * @LastEditTime: 2024-07-08 13:15:12
 * @Description: 
 */
export interface formType {
    multi: number,
    key: string,
    auto: boolean,
    value: string,
    disabled: boolean,
    sector: number,
    isSubmiting: boolean
}
// 开奖结果对应的颜色等级
export const circleColor = ["#5b6773", "#ea5656", "#28983b", "#dda800"];
// 圆盘开奖结果 如：win_sector = 1,则为circleColor[circleSectors[win_sector - 1] - 1] = 3 // #dda800
export const circleSectors = [4, 3, 1, 2, 1, 2, 1, 2, 1, 3, 1, 3, 1, 2, 1, 2, 1, 2, 1, 3, 1, 3, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 3, 1, 3, 1, 2, 1, 2, 1, 2, 1, 3, 1, 3, 1, 2, 1, 2, 1, 2, 1, 3];
// circle游戏规则数据
export const circleRulesData = [
    {
        content1: 'circleRule1',
        constent2: '',
        img: null,
    }
];
// circle form表单数据
export const formOptions = [
    {
        multi: 2.04,
        key: 'gray',
        auto: false,
        value: '0.00',
        disabled: true,
        sector: 1,
        isSubmiting: false
    },
    {
        multi: 3.12,
        key: 'red',
        auto: false,
        value: '0.00',
        disabled: true,
        sector: 2,
        isSubmiting: false
    },
    {
        multi: 5.30,
        key: 'green',
        auto: false,
        value: '0.00',
        disabled: true,
        sector: 3,
        isSubmiting: false
    },
    {
        multi: 53.03,
        key: 'yellow',
        auto: false,
        value: '0.00',
        disabled: true,
        sector: 4,
        isSubmiting: false
    },
]
export type formOptionsType = typeof formOptions;
